
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "i18n!courses.roster.roster_user";
import "coffeescripts/handlebars_helpers.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = 'courses/roster/rosterUser';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += " <i>(";
  if (helper = helpers.pronouns) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.pronouns); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + ")</i>";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "<span class=\"label label-info\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("courses.roster.roster_user")
  },data:data},helper ? helper.call(depth0, "pending_acceptance_explanation", "This user has not yet accepted the invitation to the course", options) : helperMissing.call(depth0, "t", "pending_acceptance_explanation", "This user has not yet accepted the invitation to the course", options)))
    + "\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("courses.roster.roster_user")
  },data:data},helper ? helper.call(depth0, "pending_acceptance_of_invitation", "pending", options) : helperMissing.call(depth0, "t", "pending_acceptance_of_invitation", "pending", options)))
    + "</span>";
  return buffer;
  }

function program5(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "<span class=\"label\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "this_user_is_currently_not_able_to_access_the_cour_39cabed1", "This user is currently not able to access the course", options) : helperMissing.call(depth0, "t", "this_user_is_currently_not_able_to_access_the_cour_39cabed1", "This user is currently not able to access the course", options)))
    + "\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "inactive_cd40317f", "inactive", options) : helperMissing.call(depth0, "t", "inactive_cd40317f", "inactive", options)))
    + "</span>";
  return buffer;
  }

function program7(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n<td>\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canViewLoginId), {hash:{},inverse:self.noop,fn:self.program(8, program8, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</td>\n";
  return buffer;
  }
function program8(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n    ";
  if (helper = helpers.login_id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.login_id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n  ";
  return buffer;
  }

function program10(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n<td>\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canViewSisId), {hash:{},inverse:self.noop,fn:self.program(11, program11, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</td>\n";
  return buffer;
  }
function program11(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n    ";
  if (helper = helpers.sis_id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.sis_id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n  ";
  return buffer;
  }

function program13(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n<td data-test-id=\"section-column-cell\">\n  ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.sections), {hash:{},inverse:self.noop,fn:self.program(14, program14, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</td>\n";
  return buffer;
  }
function program14(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n  <div class=\"section\">";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</div>\n  ";
  return buffer;
  }

function program16(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n  <div>"
    + escapeExpression((helper = helpers.enrollmentName || (depth0 && depth0.enrollmentName),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.role), options) : helperMissing.call(depth0, "enrollmentName", (depth0 && depth0.role), options)))
    + "</div>\n  ";
  return buffer;
  }

function program18(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n<td>\n  ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.enrollments), {hash:{},inverse:self.noop,fn:self.program(19, program19, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</td>\n<td>\n  <div>";
  if (helper = helpers.total_activity_string) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.total_activity_string); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</div>\n</td>\n";
  return buffer;
  }
function program19(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <div "
    + escapeExpression((helper = helpers.contextSensitiveDatetimeTitle || (depth0 && depth0.contextSensitiveDatetimeTitle),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.last_activity_at), options) : helperMissing.call(depth0, "contextSensitiveDatetimeTitle", (depth0 && depth0.last_activity_at), options)))
    + ">\n      "
    + escapeExpression((helper = helpers.datetimeFormatted || (depth0 && depth0.datetimeFormatted),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.last_activity_at), options) : helperMissing.call(depth0, "datetimeFormatted", (depth0 && depth0.last_activity_at), options)))
    + "\n    </div>\n  ";
  return buffer;
  }

function program21(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n  <div class=\"admin-links\">\n    <a role=\"button\" class=\"al-trigger al-trigger-gray\" href=\"javascript:void(0)\">\n      <i class=\"icon-more\" aria-hidden=\"true\"></i>\n      <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'scope': ("courses.roster.roster_user")
  },data:data},helper ? helper.call(depth0, "manage_user", "Manage %{name}", options) : helperMissing.call(depth0, "t", "manage_user", "Manage %{name}", options)))
    + "</span></a>\n    <ul class=\"al-options\">\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canResendInvitation), {hash:{},inverse:self.noop,fn:self.program(22, program22, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canLinkStudents), {hash:{},inverse:self.noop,fn:self.program(24, program24, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canEditSections), {hash:{},inverse:self.noop,fn:self.program(26, program26, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canEditRoles), {hash:{},inverse:self.noop,fn:self.program(28, program28, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      <li><a href=\"";
  if (helper = helpers.url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"><i class=\"icon-user\" aria-hidden=\"true\"></i> "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("courses.roster.roster_user")
  },data:data},helper ? helper.call(depth0, "links.user_details", "User Details", options) : helperMissing.call(depth0, "t", "links.user_details", "User Details", options)))
    + "</a></li>\n\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canRemoveUsers), {hash:{},inverse:self.noop,fn:self.program(30, program30, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.customLinks), {hash:{},inverse:self.noop,fn:self.program(35, program35, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </ul>\n  </div>\n  ";
  return buffer;
  }
function program22(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        <li><a href=\"#\" data-event=\"resendInvitation\"><i class=\"icon-email\" aria-hidden=\"true\"></i> "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("courses.roster.roster_user")
  },data:data},helper ? helper.call(depth0, "links.resend_invitation", "Resend Invitation", options) : helperMissing.call(depth0, "t", "links.resend_invitation", "Resend Invitation", options)))
    + "</a></li>\n      ";
  return buffer;
  }

function program24(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        <li><a href=\"#\" data-event=\"linkToStudents\"><i class=\"icon-link\" aria-hidden=\"true\"></i> "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("courses.roster.roster_user")
  },data:data},helper ? helper.call(depth0, "links.link_to_students", "Link to Students", options) : helperMissing.call(depth0, "t", "links.link_to_students", "Link to Students", options)))
    + "</a></li>\n      ";
  return buffer;
  }

function program26(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        <li><a href=\"#\" data-event=\"editSections\"><i class=\"icon-edit\" aria-hidden=\"true\"></i> "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("courses.roster.roster_user")
  },data:data},helper ? helper.call(depth0, "links.edit_sections", "Edit Sections", options) : helperMissing.call(depth0, "t", "links.edit_sections", "Edit Sections", options)))
    + "</a></li>\n      ";
  return buffer;
  }

function program28(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        <li><a href=\"#\" data-event=\"editRoles\"><i class=\"icon-edit\" aria-hidden=\"true\"></i> "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "edit_role_1e96ad20", "Edit Role", options) : helperMissing.call(depth0, "t", "edit_role_1e96ad20", "Edit Role", options)))
    + "</a></li>\n      ";
  return buffer;
  }

function program30(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n        <li class=\"ui-menu-item\"><hr /></li>\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isInactive), {hash:{},inverse:self.program(33, program33, data),fn:self.program(31, program31, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        <li><a href=\"#\" data-event=\"removeFromCourse\"><i class=\"icon-trash\" aria-hidden=\"true\"></i> "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("courses.roster.roster_user")
  },data:data},helper ? helper.call(depth0, "links.remove_from_course", "Remove From Course", options) : helperMissing.call(depth0, "t", "links.remove_from_course", "Remove From Course", options)))
    + "</a></li>\n      ";
  return buffer;
  }
function program31(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n          <li><a href=\"#\" data-event=\"reactivateUser\"><i class=\"icon-user\" aria-hidden=\"true\"></i>  "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "re_activate_user_f7d77c9a", "Re-activate User", options) : helperMissing.call(depth0, "t", "re_activate_user_f7d77c9a", "Re-activate User", options)))
    + "</a></li>\n        ";
  return buffer;
  }

function program33(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n          <li><a href=\"#\" data-event=\"deactivateUser\"><i class=\"icon-deactivate-user\" aria-hidden=\"true\"></i> "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "deactivate_user_86c09036", "Deactivate User", options) : helperMissing.call(depth0, "t", "deactivate_user_86c09036", "Deactivate User", options)))
    + "</a></li>\n        ";
  return buffer;
  }

function program35(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n        <li><a href=\"";
  if (helper = helpers.url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"><i class=\"";
  if (helper = helpers.icon_class) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.icon_class); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"></i> ";
  if (helper = helpers.text) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.text); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</a></li>\n      ";
  return buffer;
  }

  buffer += "<td class=\"center\">\n  <div id=";
  if (helper = helpers.avatarId) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.avatarId); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "></div>\n</td>\n<td>\n  <a href=\"";
  if (helper = helpers.html_url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.html_url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n     data-student_id=\"";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n     data-course_id=\"";
  if (helper = helpers.course_id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.course_id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n     class=\"roster_user_name student_context_card_trigger\">";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1);
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.pronouns), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</a>\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isPending), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isInactive), {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</td>\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canViewLoginIdColumn), {hash:{},inverse:self.noop,fn:self.program(7, program7, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canViewSisIdColumn), {hash:{},inverse:self.noop,fn:self.program(10, program10, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.hideSectionsOnCourseUsersPage), {hash:{},inverse:self.noop,fn:self.program(13, program13, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n<td>\n  ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.enrollments), {hash:{},inverse:self.noop,fn:self.program(16, program16, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</td>\n";
  stack1 = helpers['if'].call(depth0, ((stack1 = ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.permissions)),stack1 == null || stack1 === false ? stack1 : stack1.read_reports), {hash:{},inverse:self.noop,fn:self.program(18, program18, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n<td class=\"right\">\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canManage), {hash:{},inverse:self.noop,fn:self.program(21, program21, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</td>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  